export { TextDisplay, TextDisplayProps } from './TextDisplay';
